import BackofficeHome from "back-office/BackOffice"
import BoStatisticsView from "back-office/features/statistics-view/BoStatisticsView"
import BoDashboardLayout from "back-office/dashboard/BoDashboardLayout"
import CourtiersAdminScreen from "back-office/features/courtiers-view/CourtiersAdminScreen"
import MiasView from "back-office/features/mias-view/MiasView"
import MiasTable from "back-office/features/mias-view/MiasTable"
import PimsView from "back-office/features/pims-view/PimsView"
import PimsTable from "back-office/features/pims-view/PimsTable"
import { PersonneMoralePlateformesPage } from "back-office/features/personne-morale-plateformes/PersonneMoralePlateformesPage"
import PersonnesMoralesView from "back-office/features/personnes-morales-view/PersonnesMoralesView"
import CompagniesView from "back-office/features/personnes-morales-view/CompagniesView"
import PersonnesMoralesTable from "back-office/features/personnes-morales-view/PersonnesMoralesTable"
import PersonneMoraleDetails from "back-office/features/personnes-morales-view/PersonneMoraleDetails"
import { DocumentsView } from "back-office/features/documents-view/DocumentsView"
import ContractView from "features/contract-view/components/ContractView"
import ContractDetails from "features/contract-view/components/contract-details/ContractDetails"
import QuoteView from "features/quote-view/components/QuoteView"
import SimulationView from "features/simulation-view/components/SimulationView"
import FunnelsAdminList from "back-office/features/funnels-view/FunnelsAdminList"
import FunnelsView from "back-office/features/funnels-view/FunnelsView"
import BranchesView from "back-office/features/branches-view/BranchesView"
import IndicesView from "back-office/features/indices-view/IndicesView"
import CoproRegistryView from "back-office/features/copro-registry-view/CoproRegistryView"
import IndicesList from "back-office/features/indices-view/IndicesList"
import IndiceDetails from "back-office/features/indices-view/IndiceDetails"
import BranchesList from "back-office/features/branches-view/BranchesList"
import BranchGuarantees from "back-office/features/branches-view/BranchGuarantees"
import UnassignedGuarantees from "back-office/features/branches-view/UnassignedGuarantees"
import { UNASSIGNED_ROUTE_SEGMENT } from "back-office/features/branches-view/branchesRoutes"
import { TunnelAuditHistory } from "back-office/features/funnels-view/TunnelAuditHistory"
import { FunnelDetails } from "back-office/features/funnels-view/detail/FunnelDetails"
import { GroupContractDetails } from "back-office/features/group-contract-view/GroupContractDetails"
import GroupContractTable from "back-office/features/group-contract-view/GroupContractTable"
import GroupContractView from "back-office/features/group-contract-view/GroupContractView"
import { GroupContractProcessWrapper } from "back-office/features/group-contract-process/GroupContractProcessWrapper"
import { SubscriberStep } from "back-office/features/group-contract-process/steps/SubscriberStep"
import { ProductsStep } from "back-office/features/group-contract-process/steps/ProductsStep"
import { BrokersStep } from "back-office/features/group-contract-process/steps/BrokersStep"
import { ContractualizationStep } from "back-office/features/group-contract-process/steps/ContractualizationStep"
import PlateformesCardList from "back-office/features/plateformes-view/PlateformesCardList"
import { PlateformeCreatePage } from "back-office/features/plateformes-view/create/PlateformeCreatePage"
import { PlateformeDetails } from "back-office/features/plateformes-view/PlateformesDetails"
import {
  PlateformeCatalogueRoute,
  PlateformeGouvernanceRoute,
  PlateformeHabilitationsRoute,
  PlateformeIntermediairesRoute,
  PlateformeRolesRoute,
} from "back-office/features/plateformes-view/detail/plateformeTabRoutes"
import PlateformesView from "back-office/features/plateformes-view/PlateformesView"
import ClientsView from "back-office/features/clients-view/ClientsView"
import { ProductDetails } from "back-office/features/products-view/ProductDetails"
import ProduitsAdminScreen from "back-office/features/products-view/ProduitsAdminScreen"
import ProductsView from "back-office/features/products-view/ProductsView"
import SurveysView from "back-office/features/surveys-view/SurveysView"
import { SurveysTable } from "back-office/features/surveys-view/SurveysTable"
import { SurveyDetails } from "back-office/features/surveys-view/SurveyDetails"
import PaymentScheduleView from "back-office/features/payment-schedule-view/PaymentScheduleView"
import PrelevementsAdminList from "back-office/features/payment-schedule-view/PrelevementsAdminList"
import { PaymentScheduleDetails } from "back-office/features/payment-schedule-view/PaymentScheduleDetails"
import { HbsPrelevementsView } from "back-office/features/hbs-prelevements/HbsPrelevementsView"
import { GroupMembersPaymentsView } from "back-office/features/group-members-payments/GroupMembersPaymentsView"
import { AtelierRolesView } from "back-office/features/atelier-roles-view/AtelierRolesView"
import ConnexionsView from "back-office/features/connexions-view/ConnexionsView"
import { BoPermissionGuard } from "back-office/shared/guards/BoPermissionGuard"
import { Navigate, Route } from "react-router-dom"
import { RouteGuard } from "features/auth/guards/RouteGuard"

export const BackOfficeRoutes = () => {
  return (
    <Route
      path="back-office"
      element={
        <RouteGuard requiresAuth>
          <BoPermissionGuard>
            <BoDashboardLayout />
          </BoPermissionGuard>
        </RouteGuard>
      }
    >

      <Route index element={<Navigate to="/back-office/home" replace />} />
      <Route path="home" element={<BackofficeHome />} />
      <Route path="statistiques" element={<BoStatisticsView />} />
      <Route path="documents" element={<DocumentsView />} />
      {/* Ancien emplacement (la plateforme n'est pas un acteur) : redirection. */}
      <Route path="acteurs/plateformes/*" element={<Navigate to="/back-office/plateformes" replace />} />
      <Route path="plateformes" element={<PlateformesView />} >
        <Route index element={<PlateformesCardList />} />
        <Route path="new" element={<PlateformeCreatePage />} />
        {/* Onglets de la fiche en routes imbriquées : l'URL porte l'onglet actif
            (précédent/suivant et deep links tombent au bon endroit). */}
        <Route path=":plateformeId" element={<PlateformeDetails />}>
          <Route index element={<Navigate to="gouvernance" replace />} />
          <Route path="gouvernance" element={<PlateformeGouvernanceRoute />} />
          <Route path="intermediaires" element={<PlateformeIntermediairesRoute />} />
          <Route path="catalogue" element={<PlateformeCatalogueRoute />} />
          <Route path="roles" element={<PlateformeRolesRoute />} />
          <Route path="habilitations" element={<PlateformeHabilitationsRoute />} />
          <Route path="*" element={<Navigate to="gouvernance" replace />} />
        </Route>
      </Route>
      <Route path="acteurs/courtiers">
        <Route index element={<CourtiersAdminScreen />} />
        <Route path=":brokerId" element={<>details</>} />
      </Route>
      <Route path="acteurs/mias" element={<MiasView />}>
        <Route index element={<MiasTable />} />
      </Route>
      <Route path="acteurs/pims" element={<PimsView />}>
        <Route index element={<PimsTable />} />
      </Route>
      <Route path="acteurs/compagnies" element={<CompagniesView />} />
      <Route path="acteurs/personnes-morales" element={<PersonnesMoralesView />}>
        <Route index element={<PersonnesMoralesTable />} />
        <Route path=":personneMoraleId" element={<PersonneMoraleDetails />} />
      </Route>
      <Route path="acteurs/personnes-morales/:personneMoraleId/plateformes" element={<PersonneMoralePlateformesPage />} />
      <Route path="acteurs/clients" element={<ClientsView admin />} />
      <Route path="atelier-roles" element={<AtelierRolesView />} />
      <Route path="admin/connexions" element={<ConnexionsView />} />
      <Route path="produits" element={<ProductsView />}>
        <Route index element={<ProduitsAdminScreen />} />
        <Route path=":productId" element={<ProductDetails />} />
      </Route>
      <Route path="contrats-groupe" element={<GroupContractView />}>
        <Route index element={<GroupContractTable />} />
        <Route path=":groupContractId" element={<GroupContractDetails />} />
      </Route>
      <Route path="contrats-groupe/process/:groupContractId" element={<GroupContractProcessWrapper />}>
        <Route index element={<Navigate to="souscripteur" replace />} />
        <Route path="souscripteur" element={<SubscriberStep />} />
        <Route path="produits" element={<ProductsStep />} />
        <Route path="courtiers" element={<BrokersStep />} />
        <Route path="contractualisation" element={<ContractualizationStep />} />
      </Route>
      <Route path="tunnels" element={<FunnelsView />}>
        <Route index element={<FunnelsAdminList />} />
        <Route path=":tunnelId" element={<FunnelDetails />} />
        <Route path=":tunnelId/audit-history" element={<TunnelAuditHistory />} />
      </Route>
      <Route path="branches" element={<BranchesView />}>
        <Route index element={<BranchesList />} />
        {/* Segment réservé, placé avant :brancheId qui n'accepte que des uuid. */}
        <Route path={UNASSIGNED_ROUTE_SEGMENT} element={<UnassignedGuarantees />} />
        <Route path=":brancheId" element={<BranchGuarantees />} />
      </Route>
      <Route path="indices" element={<IndicesView />}>
        <Route index element={<IndicesList />} />
        <Route path=":indiceId" element={<IndiceDetails />} />
      </Route>
      <Route path="registre-coproprietes" element={<CoproRegistryView />} />
      <Route path="questionnaires" element={<SurveysView />}>
        <Route index element={<SurveysTable />} />
        <Route path=":surveyId" element={<SurveyDetails />} />
      </Route>
      <Route path="prelevements" element={<PaymentScheduleView />}>
        <Route index element={<PrelevementsAdminList />} />
        <Route path="hbs" element={<HbsPrelevementsView />} />
        <Route path="aliments" element={<GroupMembersPaymentsView />} />
        <Route path=":paymentScheduleId" element={<PaymentScheduleDetails />} />
      </Route>
      <Route path="contrats">
        <Route index element={<ContractView hideCreate admin />} />
        <Route path="details/:id" element={<ContractDetails />} />
      </Route>
      <Route path="devis" element={<QuoteView hideCreate admin />} />
      <Route path="simulations" element={<SimulationView hideCreate admin />} />
    </Route>
  )
}
